export default [
  {
    value: 'Website Design',
    text: 'Website Design'
  },
  {
    value: 'Website Development',
    text: 'Website Development'
  },
  {
    value: 'Mobile app Development',
    text: 'Mobile app Development'
  },
  {
    value: 'SEO',
    text: 'SEO'
  },
  {
    value: 'Email Marketing',
    text: 'Email Marketing'
  },
  {
    value: 'Social Media Management',
    text: 'Social Media Management'
  },
  {
    value: 'Team training',
    text: 'Team training'
  }
]